{
  "title": "Water Walk",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level transmutation (ritual)",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a piece of cork)",
  "duration": "1 hour",
  "description": [
    "This spell grants the ability to move across any liquid surface – such as water, acid, mud, snow, quicksand, or lava – as if it were harmless solid ground (creatures crossing molten lava can still take damage from the heat). Up to ten willing creatures you can see within range gain this ability for the duration.",
    "If you target a creature submerged in a liquid, the spell carries the target to the surface of the liquid at a rate of 60 feet per round."
  ],
  "spellLists": ["artificer", "cleric", "druid", "ranger", "sorcerer"]
}
